// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandsTable_container__2dzGq","check":"BrandsTable_check__NfPa6","enableCell":"BrandsTable_enableCell__oSk5T"};